import React from 'react';

function ButtonSpinner(){
  return <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
}

export default ButtonSpinner;